/**
 * AdminOrcaProjectRpcClient - AtomRpc integration for admin orca project endpoints
 *
 * Requires admin authentication via Clerk session token.
 *
 * @since 1.0.0
 */
import { AtomRpc } from "@effect-atom/atom-react";
import { FetchHttpClient } from "@effect/platform";
import { RpcSerialization } from "@effect/rpc";
import { AdminOrcaProjectRpcs } from "@fm/api/rpc";
import { Layer } from "effect";
import { makeRpcClientLayer, makeTokenGetterLayer } from "./shared.ts";

export class AdminOrcaProjectRpcClient extends AtomRpc.Tag<AdminOrcaProjectRpcClient>()(
  "AdminOrcaProjectRpcClient",
  {
    group: AdminOrcaProjectRpcs,
    protocol: makeRpcClientLayer(AdminOrcaProjectRpcs).pipe(
      Layer.provide(RpcSerialization.layerNdjson),
      Layer.provide(makeTokenGetterLayer()),
      Layer.provide(FetchHttpClient.layer),
    ),
  },
) {}
